__turbopack_context__.v({
  "dropzone": "NRGi3a_dropzone",
  "dropzoneHint": "NRGi3a_dropzoneHint",
  "withPreview": "NRGi3a_withPreview",
});
